import { render, staticRenderFns } from "./InfoPopoverComparison.vue?vue&type=template&id=720f2e85&scoped=true"
import script from "./InfoPopoverComparison.vue?vue&type=script&lang=js"
export * from "./InfoPopoverComparison.vue?vue&type=script&lang=js"
import style0 from "./InfoPopoverComparison.vue?vue&type=style&index=0&id=720f2e85&prod&scoped=true&lang=css"
import style1 from "./InfoPopoverComparison.vue?vue&type=style&index=1&id=720f2e85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f2e85",
  null
  
)

export default component.exports